import { Flex, Typography } from "antd";
import { useMemo } from "react";
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { datetime } from "../../../../util/library/datetime";
import { IActivityLog, IService2 } from "../../../../util/varibles/interface";
import { ChecklistsSection } from "../ChecklistsForm";
import FinishStepButton from "../FinishStepButton";

export default function Completed({ log, start }: { log: IActivityLog, start: IActivityLog }) {
    const [op] = useTrackingOp(state => state.op?.operation as IService2);
    const { checklists_v2 = [], crew_tasks = [] } = op || {};

    const isDone = useMemo(() => crew_tasks.length === 0 || crew_tasks.every(item => item.real_finish_time), [crew_tasks])

    const { real_start_time } = start || {}
    const { depature_time, real_start_time: real_departure_time } = log;

    return <>
        <div className="w-full">
            <Flex gap={6}>
                <Typography.Text type="secondary">Start: </Typography.Text>
                <Typography.Text>{real_start_time ? datetime(real_start_time).format("HH:mm. DD/MM") : '--'}</Typography.Text>
            </Flex>
            <Flex gap={6}>
                <Typography.Text type="secondary">Departure:</Typography.Text>
                <Typography.Text>{(depature_time || real_departure_time) ? datetime(depature_time || real_departure_time).format("HH:mm. DD/MM") : '--'}</Typography.Text>
            </Flex>
            <ChecklistsSection data={checklists_v2} />
        </div>
        {isDone && <FinishStepButton name="Completed" payload={{ movement_type: "complete" }} />}
    </>
}